import React from 'react';
import {
  Box,
  Inscription,
  NotFoundImagePlaceholderIcon,
} from '@common-fe/common-fe';
import styled from 'styled-components';

const Wrapp = styled(Box)`
  ${({ theme }) => theme.shadows.default};
  outline: 1px solid ${({ theme }) => theme.colors.border1};
  outline-offset: -3px;
`;

const StyledNotFoundImagePlaceholderIcon = styled(NotFoundImagePlaceholderIcon)`
  width: ${({ theme }) => theme.spacings.spacing72};
  height: ${({ theme }) => theme.spacings.spacing72};
  fill: ${({ theme }) => theme.colors.border};
`;

interface Props {
  title: string;
}

const NoReceipts: React.FC<Props> = ({ title }) => (
  <Wrapp
    height="380px"
    background="canvas"
    margin={{ bottom: 'spacing12' }}
    round="container1Round"
    justify="center"
    align="center"
  >
    <StyledNotFoundImagePlaceholderIcon />

    {title && (
      <Inscription
        margin={{ top: 'spacing24' }}
        color="textDisabled"
        lineHeight="20px"
      >
        {title}
      </Inscription>
    )}
  </Wrapp>
);

export default NoReceipts;
